import React, {Component} from 'react';
import InspectionHeader from './components/inspection-header';
import InspectionBody from './components/inspection-body';
import InspectionDetailAction from '../../../../redux/actions/inspection';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {MESSAGES_NOTIFY, CONFIG_NOTIFY} from '../../../../constants/app/inspection';
import {STATUS_SERVICE} from '../../../../constants/app/services';
import ModalResolve from './components/resolve/modal-resolve';
import ModalObservation from './components/observations/modal-observation';
import ModalDerivation from './components/derivations/modal-derivations';
import ModalApprove from './components/approves/modal-approves';
import {Redirect} from 'react-router-dom'
import ModalReturns from './components/returns/modal-return';
import ModalMoreReasons from './components/moreReasons/modal-more-reasons';
import ModalMoreReasonsRejected from './components/reasonsRejected/modal-more-reasons-rejected';
import TransformInspection from '../../../../lib/utils/transforms/inspection';
import {
    INSPECTION_STATE_CODE,
    DERIVATIONS_REASONS,
    REJECTED_REASONS
} from '../../../../constants/app/inspection';
import ModalInPerson from "./components/inPerson/modal-in-person";
import ModalChangeToCreate from "./components/change-to-create/modal-change-to-create";
import ModalRemoveInspections from "./components/remove-inspections/modal-remove-inspections";
/* Importamos el modal desde la carpeta components */
import ModalChangeToReturn from "./components/change-to-return/modal-change-to-return";

class Inspection extends Component {
    state = {
        userIdentity: this.props.match.params.userIdentity,
        requestId: this.props.match.params.requestId,
        comments: '',
        isDisabled: true,
        openModal: false,
        openModalObservation: false,
        openModalDerivation: false,
        openModalApprove: false,
        openModalInPerson: false,
        openModalChangeToCreate: false,
        openModalChangeToReturn:false,
        openModalReturn: false,
        openModalRemoveInspections: false,
        isApproved: true,
        lastState: {},
        typeObservation: '',
        indexObservation: -1,
        observationSelected: null,
        derivationsSelected: null,
        allObservations: [],
        disabledConfirm: false,
        reasonsDerivations: [],
        reasonsReject: [],
        goDashboard: false,
        openModalMoreReasons: false,
        openModalMoreReasonsRejected: false,
        reasonsObservations: [],
        isEditMode: false
    };

    componentDidMount() {
        const {userIdentity, requestId} = this.state;

        this.props.loadInspection(userIdentity, requestId);
    }

    componentDidUpdate() {
        if (this.props.presencial === STATUS_SERVICE.SUCCESS) {
            this.props.presencialInspectionReset();
            this.setState({openModal: false, goDashboard: true});
        }
        if (this.props.approved === STATUS_SERVICE.SUCCESS) {
            this.props.approvedInspectionReset();
            this.setState({openModal: false});
        }
        if (this.props.rejected === STATUS_SERVICE.SUCCESS) {
            this.props.rejectedInspectionReset();
            this.setState({openModal: false}, () => {
                setTimeout(() => {
                    this.loadReasonsRejected();
                }, 3000)
            });
        }
        if (this.props.returned === STATUS_SERVICE.SUCCESS) {
            this.props.returnInspectionReset();
            this.setState({openModalReturn: false});
        }
        if (this.props.derived === STATUS_SERVICE.SUCCESS) {
            this.props.deriveInspectionReset();
            this.setState({openModalDerivation: false}, () => {
                setTimeout(() => {
                    this.loadReasons();
                }, 3000)
            });
        }
        if (this.props.inspection.vehiclePlate !== undefined) {
            this.props.inspection.vehiclePlate.toUpperCase();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.inspection) {
            if (nextProps.inspection.state && nextProps.inspection.state.inspectionStatus === 'REJECTED') {
                this.loadReasonsRejected();
            }
            if ((nextProps.inspection.state && nextProps.inspection.state.inspectionStatus === 'DERIVE') || (nextProps.inspection.state && nextProps.inspection.state.inspectionStatus === 'APPROVED')) {
                this.loadReasons();
            }
        }
    }

    loadReasons = () => {
        let aux = [];

        if (this.props.inspection.derivedReason && this.props.inspection.derivedReason.length > 0) {
            const reasonsByService = this.props.inspection.derivedReason.split(",");
            reasonsByService.forEach((reason) => {
                DERIVATIONS_REASONS.forEach((deri) => {
                    if (deri.id === reason) {
                        aux.push({id: reason, label: deri.label});
                    }
                })
            });
            this.setState({reasonsDerivations: aux});
        }
    };

    loadReasonsRejected = () => {
        let auxReject = [];

        if (this.props.inspection.rejectReason && this.props.inspection.rejectReason.length > 0) {
            const reasonsByService = this.props.inspection.rejectReason.split(",");
            reasonsByService.forEach((reason) => {
                REJECTED_REASONS.forEach((rejec) => {
                    if (rejec.id === reason) {
                        auxReject.push({id: reason, label: rejec.label});
                    }
                })
            });
            this.setState({reasonsReject: auxReject});
        }
    };

    registerPicturesObserved = (pictures) => {
        const {userIdentity, requestId} = this.state

        const itemsObserved = pictures.map(pic => ({
            attachedId: pic.id,
            attachment: pic.type,
            observeCode: pic.observationCode
        }));
        this.props.returnInspection(itemsObserved);
    };

    openModalMoreReasons = () => {
        const {openModalMoreReasons} = this.state;

        this.setState({openModalMoreReasons: !openModalMoreReasons});
    };

    openModalMoreReasonsRejected = () => {
        const {openModalMoreReasonsRejected} = this.state;

        this.setState({openModalMoreReasonsRejected: !openModalMoreReasonsRejected});
    };

    openDerivationInspection = () => {
        const {openModalDerivation} = this.state;

        this.setState({openModalDerivation: !openModalDerivation})
    };

    openApproveInspection = () => {
        const {openModalApprove} = this.state;

        this.setState({openModalApprove: !openModalApprove})
    };

    openReturnToInPersonInspection = () => {
        const {openModalInPerson} = this.state;
        this.setState({openModalInPerson: !openModalInPerson});
    };

    openChangeInPersonToCreate = () => {
        const {openModalChangeToCreate} = this.state;
        this.setState({openModalChangeToCreate: !openModalChangeToCreate});
    };

    openChangeInPersonToReturn = () => {
        const {openModalChangeToReturn} = this.state;
        this.setState({openModalChangeToReturn: !openModalChangeToReturn});
    };

    openRemoveInspections = () => {
        const {openModalRemoveInspections} = this.state;
        this.setState({openModalRemoveInspections: !openModalRemoveInspections})
    };

    closeModal = () => {
        this.setState({openModal: false});
    };

    closeModalObservation = () => {
        this.setState({openModalObservation: false, reasonsObservations: []});
    };

    closeModalReturn = () => {
        this.setState({openModalReturn: false});
    };

    closeDerivationInspection = () => {
        const {openModalDerivation} = this.state;

        this.setState({openModalDerivation: false, reasonsDerivations: []});
    };

    closeApproveInspection = () => {
        this.setState({openModalApprove: false});
    };

    closeModalInPerson = () => {
        this.setState({openModalInPerson: false});
    };

    closeModalChangeInPersonToCreate = () => {
        this.setState({openModalChangeToCreate: false});
    };

    closeModalChangeInPersonToReturn= () => {
        this.setState({openModalChangeToReturn: false});
    };

    closeModalRemoveInspections = () => {
        this.setState({openModalRemoveInspections: false});
    };

    handleComment = (e) => {
        this.setState({isDisabled: !(e.target.value.length), comments: e.target.value});
    };

    handleResolve = () => {
        if (this.props.inspection && this.props.inspection.damages && this.props.inspection.damages.length > 0) {
            if (this.props.inspection.damageCommentDB.length) {
                this.setState({openModal: true, isApproved: true})
            } else {
                toast.warning(MESSAGES_NOTIFY.MESSAGE_ERROR_SAVE_COMMENT, CONFIG_NOTIFY);
            }
        } else {
            this.setState({openModal: true, isApproved: true})
        }
    };

    handleSelect = (option) => () => {
        const {isApproved} = this.state;

        if (isApproved) {
            this.setState({reasonsReject: []});
        }
        this.setState({isApproved: option});
    };

    handleModalObservation = (typeObservation) => (indexObservation) => {
        let observationSelected;
        let image;

        switch (typeObservation) {
            case 'picture':
                image = this.props.inspection.pictures[indexObservation];
                observationSelected = image.observationCode;
                break;
            case 'accessory':
                image = this.props.inspection.accessories[indexObservation];
                observationSelected = image.observationCode;
                break;
            case 'damage':
                image = this.props.inspection.damages[indexObservation];
                observationSelected = image.observationCode;
                break;
            default:
                image = {};
                observationSelected = '';
                break;
        }

        if (this.props.inspection.state.inspectionStatus === INSPECTION_STATE_CODE.SENT) {
            if (image.files.length) {
                if (!image.selected) {
                    this.setState({openModalObservation: true, typeObservation, indexObservation, observationSelected});
                } else {
                    switch (typeObservation) {
                        case 'picture':
                            this.props.removePictureObservation(indexObservation);
                            break;
                        case 'accessory':
                            this.props.removeAccessoryObservation(indexObservation);
                            break;
                        case 'damage':
                            this.props.removeDamageObservation(indexObservation);
                            break;
                    }
                    this.props.validateButtonObservation();
                }
            }
        }

    };

    handleReturnInspection = () => {
        const allPicturesObserved = TransformInspection.getPicturesWithObservations(this.props.inspection.pictures, this.props.inspection.damages, this.props.inspection.accessories);

        this.setState({allObservations: allPicturesObserved, openModalReturn: true});
    };

    handleConfirmObservation = () => {
        const {typeObservation, indexObservation, observationSelected, allObservations, reasonsObservations} = this.state;
        const reasonsString = (reasonsObservations && reasonsObservations.length > 0) ? reasonsObservations.join(",") : '';

        if (reasonsString) {
            switch (typeObservation) {
                case 'picture':
                    this.props.addPictureObservation(indexObservation, reasonsString);
                    break;
                case 'accessory':
                    this.props.addAccessoryObservation(indexObservation, reasonsString);
                    break;
                case 'damage':
                    this.props.addDamageObservation(indexObservation, reasonsString);
                    break;
            }
            this.props.validateButtonObservation();
            this.setState({openModalObservation: false, reasonsObservations: []});
        } else {
            toast.warning("Debe seleccionar un motivo de devolución", CONFIG_NOTIFY)
        }
    };

    handlePresencial = () => {
        const {userIdentity, requestId} = this.state;
        const body = {
            dayleft: 0,
            send: false
        };

        this.props.presencialInspection(userIdentity, requestId, body);
    };

    handleConfirmReturn = () => {
        this.registerPicturesObserved(this.state.allObservations)
    };

    handleConfirmRejectInspection = () => {
        const {reasonsReject} = this.state;

        if (reasonsReject.length > 0) {
            const getReasons = reasonsReject && reasonsReject.map(reason => reason.id);
            const reasonCode = getReasons.join(",");
            this.props.rejectedInspection(reasonCode);
        } else {
            toast.warning(MESSAGES_NOTIFY.MESSAGE_ERROR_REASON_REJECTED, CONFIG_NOTIFY);
        }
    };

    handleConfirmDerivation = () => {
        const {reasonsDerivations} = this.state;

        if (reasonsDerivations.length > 0) {
            const getReasons = reasonsDerivations && reasonsDerivations.map(reason => reason.id);
            const reasonCode = getReasons.join(",");
            this.props.deriveInspection(reasonCode);
        } else {
            toast.warning(MESSAGES_NOTIFY.MESSAGE_ERROR_REASON_DERIVED, CONFIG_NOTIFY);
        }
    };

    handleChangeObservation = (observationSelected) => () => {
        const reasonsObservationsAux = [...this.state.reasonsObservations];
        if (observationSelected.length > 0) {
            let isRepeat = false;
            if (reasonsObservationsAux.length > 0) {
                reasonsObservationsAux.forEach((reason) => {
                    if ((reason === observationSelected) && !isRepeat) {
                        for (let i = 0; i <= reasonsObservationsAux.length; i++) {
                            let obj = reasonsObservationsAux[i];

                            if (obj === reason) {
                                reasonsObservationsAux.splice(i, 1);
                                i--;
                            }
                        }
                        isRepeat = true;
                    } else {
                        const validateRepeatReasons = [...reasonsObservationsAux];
                        if (validateRepeatReasons.pop() !== observationSelected) {
                            reasonsObservationsAux.push(observationSelected);
                            this.setState({reasonsObservations: reasonsObservationsAux});
                        }
                    }
                });
                this.setState({reasonsObservations: reasonsObservationsAux});
            } else {
                reasonsObservationsAux.push(observationSelected);
                this.setState({reasonsObservations: reasonsObservationsAux});
            }
        }
    };

    handleChangeReasons = (reason) => {
        let diselected = false;
        const {reasonsReject, reasonsDerivations, isApproved} = this.state;

        if (!isApproved) {
            if (reasonsReject.length > 0) {
                reasonsReject.forEach((elmt) => {
                    if (elmt.id === reason.id) {
                        for (let i = 0; i <= reasonsReject.length; i++) {
                            let obj = reasonsReject[i];

                            if (obj.id === reason.id) {
                                reasonsReject.splice(i, 1);
                                i--;
                                diselected = true;
                                return;
                            }
                        }
                    }
                });

                if (!diselected) {
                    reasonsReject.push({id: reason.id, label: reason.label, isChecked: true});
                    return this.setState({reasonsReject});
                }
                return this.setState({reasonsReject});
            }
            reasonsReject.push({id: reason.id, label: reason.label, isChecked: true});
            this.setState({reasonsReject});
        } else {
            if (reasonsDerivations.length > 0) {
                reasonsDerivations.forEach((elmt) => {
                    if (elmt.id === reason.id) {
                        for (var i = 0; i <= reasonsDerivations.length; i++) {
                            let obj = reasonsDerivations[i];

                            if (obj.id === reason.id) {
                                reasonsDerivations.splice(i, 1);
                                i--;
                                diselected = true;
                                return;
                            }
                        }
                    }
                });

                if (!diselected) {
                    reasonsDerivations.push({id: reason.id, label: reason.label, isChecked: true});
                    return this.setState({reasonsDerivations});
                }
                return this.setState({reasonsDerivations});
            }
            reasonsDerivations.push({id: reason.id, label: reason.label, isChecked: true});
            this.setState({reasonsDerivations});
        }
    };

    handleReturnToApproved = () => {
        this.props.returnToApproved();
        this.setState({openModalApprove: false});
    };

    handleReturnToInPerson = () => {
        this.props.returnToInPerson();
        this.setState({openModalInPerson: false});
    };

    handleInPersonToCreate = () => {
        this.props.changeInPersonToCreate();
        this.setState({openModalChangeToCreate: false});
    };

    handleInPersonToReturn = () => {
        this.props.changeInPersonToReturn();
        this.setState({openModalChangeToReturn: false});
    };

    handleActiveEditMode = () => {
        const {isEditMode} = this.state;
        this.setState({isEditMode: !isEditMode});
    };

    handleEditVehiclePlate = () => {
        const payload = {
            userIdentity: this.state.userIdentity,
            requestId: Number(this.state.requestId),
            newVehiclePlate: this.props.inspection.vehiclePlate.toUpperCase()
        };
        this.props.updateVehiclePlate(payload);
    };

    handleRemoveInspections = () => {
        const inspectionsArray = [
            {
                requestId: Number(this.state.requestId),
                userIdentity: this.state.userIdentity,
            }
        ];
        this.props.removeInspections(inspectionsArray);
        this.setState({openModalRemoveInspections: false});
        setTimeout(() => {
            window.history.back();
        }, 3000);
    };

    render() {
        const {
            openModal, isApproved, observationSelected, derivationsSelected, openModalObservation, openModalReturn,
            allObservations, openModalDerivation, openModalApprove, openModalInPerson,
            openModalChangeToCreate, openModalChangeToReturn, reasonsDerivations, openModalMoreReasons, picturesObserveds, reasonsReject,
            openModalMoreReasonsRejected, goDashboard, isEditMode, openModalRemoveInspections
        } = this.state;
        if (goDashboard) {
            return <Redirect to='/dashboard'/>
        }

        return (
            <div>
                <ModalResolve
                    open={openModal}
                    handleSelect={this.handleSelect}
                    isApproved={isApproved}
                    inspection={this.props.inspection}
                    handleClose={this.closeModal}
                    handleApprove={this.props.approvedInspection}
                    handleReject={this.handleConfirmRejectInspection}
                    status={this.props.status}
                    handleChangeRejected={this.handleChangeReasons}
                    handlePresencial={this.handlePresencial}
                />
                <ModalDerivation
                    open={openModalDerivation}
                    handleClose={this.closeDerivationInspection}
                    handleOk={this.handleConfirmDerivation}
                    handleChangeDerivation={this.handleChangeReasons}
                    derivationsSelected={derivationsSelected}
                    reasonsDerivations={reasonsDerivations}
                />
                <ModalApprove
                    open={openModalApprove}
                    handleClose={this.closeApproveInspection}
                    handleOk={this.handleReturnToApproved}
                />
                <ModalInPerson
                    open={openModalInPerson}
                    handleClose={this.closeModalInPerson}
                    handleOk={this.handleReturnToInPerson}
                />
                <ModalChangeToCreate
                    open={openModalChangeToCreate}
                    handleClose={this.closeModalChangeInPersonToCreate}
                    handleOk={this.handleInPersonToCreate}
                />
                
                <ModalChangeToReturn
                    open={openModalChangeToReturn}
                    handleClose={this.closeModalChangeInPersonToReturn}
                    handleOk={this.handleInPersonToReturn}
                />


                <ModalMoreReasons
                    open={openModalMoreReasons}
                    handleClose={this.openModalMoreReasons}
                    reasonsDerivations={reasonsDerivations}
                />
                <ModalMoreReasonsRejected
                    open={openModalMoreReasonsRejected}
                    handleClose={this.openModalMoreReasonsRejected}
                    reasonsReject={reasonsReject}
                />
                <ModalObservation
                    open={openModalObservation}
                    handleClose={this.closeModalObservation}
                    handleOk={this.handleConfirmObservation}
                    handleChangeObservation={this.handleChangeObservation}
                    observationSelected={observationSelected}
                />
                <ModalReturns
                    open={openModalReturn}
                    handleClose={this.closeModalReturn}
                    handleOk={this.handleConfirmReturn}
                    picturesObserverd={allObservations}
                    status={this.props.status}
                />
                <ModalRemoveInspections
                    open={openModalRemoveInspections}
                    handleClose={this.closeModalRemoveInspections}
                    handleOk={this.handleRemoveInspections}
                />
                <div className="ui-form pt60">
                    <div className="bg-top bh433"/>
                    <div className="ui-container">
                        <div className="ui-content-detail">
                            <div className="Dashboard-inspections">
                                <InspectionHeader
                                    policy={this.props.inspection.policy}
                                    customer={this.props.inspection.customer}
                                    inspection={this.props.inspection}
                                    resolveInspection={this.handleResolve}
                                    picturesObserveds={picturesObserveds}
                                    reasonsDerivations={reasonsDerivations}
                                    disabled={(!(this.props.inspection && this.props.inspection.pictures))}
                                    state={this.props.inspection.state}
                                    enabledObservation={this.props.enabledObservation}
                                    returnInspection={this.handleReturnInspection}
                                    derivationInspection={this.openDerivationInspection}
                                    approveInspection={this.openApproveInspection}
                                    returnToInPersonInspection={this.openReturnToInPersonInspection}
                                    inPersonToCreateInspection={this.openChangeInPersonToCreate}
                                    //InPersonToReturnInspection
                                    inPersonToReturnInspection={this.openChangeInPersonToReturn}
                                    openModalReasons={this.openModalMoreReasons}
                                    openModalMoreReasonsRejected={this.openModalMoreReasonsRejected}
                                    reasonsReject={reasonsReject}
                                    isEditMode={isEditMode}
                                    activeEditMode={this.handleActiveEditMode}
                                    updateVehiclePlate={this.handleEditVehiclePlate}
                                    removeInspections={this.openRemoveInspections}
                                />
                                <InspectionBody {...this.props} handleModalObservation={this.handleModalObservation}/>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    inspection: state.InspectionDetailReducer.inspection,
    approved: state.InspectionDetailReducer.status.approved,
    returned: state.InspectionDetailReducer.status.returned,
    rejected: state.InspectionDetailReducer.status.rejected,
    derived: state.InspectionDetailReducer.status.derived,
    enabledObservation: state.InspectionDetailReducer.enabledObservation,
    status: state.InspectionDetailReducer.status,
    presencial: state.InspectionDetailReducer.status.presencial
});

const mapDispatchToProps = dispatch => bindActionCreators({
    loadInspection: InspectionDetailAction.loadInspection,
    saveCommentsDamages: InspectionDetailAction.saveCommentsDamages,
    saveCommentsPictures: InspectionDetailAction.saveCommentsPictures,
    approvedInspectionReset: InspectionDetailAction.approvedInspectionReset,
    deriveInspectionReset: InspectionDetailAction.deriveInspectionReset,
    approvedInspection: InspectionDetailAction.approvedInspection,
    returnToApproved: InspectionDetailAction.returnToApproved,
    returnToInPerson: InspectionDetailAction.returnToInPerson,
    changeInPersonToCreate: InspectionDetailAction.changeInPersonToCreate,
    //Programar el action del boton
    changeInPersonToReturn: InspectionDetailAction.changeInPersonToReturn,
    updateVehiclePlate: InspectionDetailAction.updateVehiclePlateInspection,
    removeInspections: InspectionDetailAction.removeInspections,
    rejectedInspectionReset: InspectionDetailAction.rejectedInspectionReset,
    rejectedInspection: InspectionDetailAction.rejectedInspection,
    deriveInspection: InspectionDetailAction.deriveInspection,
    returnInspection: InspectionDetailAction.returnInspection,
    returnInspectionReset: InspectionDetailAction.returnInspectionReset,
    changeCommentsDamages: InspectionDetailAction.changeCommentsDamages,
    changeCommentsPictures: InspectionDetailAction.changeCommentsPictures,
    addPictureObservation: InspectionDetailAction.addPictureObservation,
    removePictureObservation: InspectionDetailAction.removePictureObservation,
    validateButtonObservation: InspectionDetailAction.validateButtonObservation,
    addAccessoryObservation: InspectionDetailAction.addAccessoryObservation,
    removeAccessoryObservation: InspectionDetailAction.removeAccessoryObservation,
    addDamageObservation: InspectionDetailAction.addDamageObservation,
    removeDamageObservation: InspectionDetailAction.removeDamageObservation,
    presencialInspection: InspectionDetailAction.presencialInspection,
    presencialInspectionReset: InspectionDetailAction.presencialInspectionReset,
    registerPicturesObserved: InspectionDetailAction.registerPicturesObserved
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Inspection);



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/index.js